import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"

/**
 * Shown in place of the payment form when the payment could not be
 * initialized (e.g. the stock reservation failed). A project fragment can
 * override it to map its own error codes.
 */
const CheckoutPaymentInitError = ({ store, error, onRetry }) => {
  const texts = TextBundle({ id: "aldoo-store" })
  const code = error?.error || error?.message || "payment_init_failed"
  const message = texts?.[code] || error?.message || texts?.payment_init_failed || "We could not prepare your payment. Please try again."

  return (
    <div className="w-full min-h-[300px] flex flex-col items-center justify-center gap-4 px-6 text-center">
      <ExclamationTriangleIcon className="w-12 h-12 text-error" />
      <Typography variant="info_18" className="text-text my-0">
        {message}
      </Typography>
      <div className="flex gap-3">
        <Button variant="secondary_s" onClick={() => { store.hideCheckout(); store.showCart() }}>
          {texts?.back_to_cart || "Back to cart"}
        </Button>
        <Button variant="primary_s" onClick={onRetry}>
          {texts?.retry || "Retry"}
        </Button>
      </div>
    </div>
  )
}

export default CheckoutPaymentInitError
